/* DEVELOPER NOTE:
	Beast B4 migration port-forward (Select2 -> pict-section-picker): the "MaterialsLabSelector" EDIT
	theme now renders via the Picker stack, attaching MaterialsLabPicker (the SampleLabJoin reconcile +
	SampleLabAdd promotion target). The Edit variants are BESPOKE reproductions of the Picker chrome
	(not bare references) because this selector carries surface the shared templates lack: the tracking-
	GUID slot and the {~HCS:Record.PictForm.Hidden~} hide wrapper. Element ids match the Picker
	templates exactly (PICKER-FOR- / PICKER-TABULAR-), so the provider mounts unchanged. READ / PRINT
	now render via PickerDisplay (B5 display port).
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (+ tracking + Hidden wrap) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsLabPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (tabular) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~Required:Record~}
						data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML-Partial*/`
						value="" />
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsLabPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host"></span>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   B5 display port: rendered by the Picker stack's PickerDisplay (PICKER-DISPLAY-* nodes) instead of
	   the legacy Materials*Display — resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same PickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
